export const badgeRandomizer = () => {
    const container = document.querySelector(".badgeSec__random");
    if (!container) return;

    const totalBadges = 15;
    const pickedCount = 9;

    // Initial setup
    let currentSet = new Set();
    const allIndices = Array.from({ length: totalBadges }, (_, i) => i + 1);

    // Helper to get random unique numbers excluding a specific set
    const getRandomBatch = (excludeSet, count) => {
        const available = allIndices.filter(n => !excludeSet.has(n));

        // Shuffle available
        for (let i = available.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [available[i], available[j]] = [available[j], available[i]];
        }

        return available.slice(0, count);
    };

    // Initial draw
    const initialBatch = getRandomBatch(new Set(), pickedCount);
    currentSet = new Set(initialBatch);

    // Initial HTML Generation
    let html = "";
    initialBatch.forEach((num) => {
        const numStr = num.toString().padStart(2, "0");
        html += `
            <div class="badge-flip-container">
                <div class="badge-flipper">
                    <div class="badge-front">
                        <img src="./assets/images/badge/badge-${numStr}.png" alt="Badge ${numStr}" data-badge-id="${num}">
                    </div>
                    <div class="badge-back">
                        <img src="" alt="" data-badge-id="">
                    </div>
                </div>
            </div>
        `;
    });
    container.innerHTML = html;

    const flippers = container.querySelectorAll(".badge-flipper");

    // Interval Logic
    setInterval(() => {
        // 1. Pick 2-3 random indices from the 9 currently displayed
        const numToChange = Math.floor(Math.random() * 2) + 2; // Returns 2 or 3
        const indicesToChange = [];
        const availableIndices = Array.from({ length: pickedCount }, (_, i) => i);

        for (let i = 0; i < numToChange; i++) {
            const randomIndex = Math.floor(Math.random() * availableIndices.length);
            indicesToChange.push(availableIndices[randomIndex]);
            availableIndices.splice(randomIndex, 1);
        }

        // Get new unique IDs for the slots we are changing
        const newBadges = getRandomBatch(currentSet, numToChange);

        indicesToChange.forEach((domIndex, i) => {
            const flipper = flippers[domIndex];
            const isFlipped = flipper.classList.contains("is-flipped");
            const newId = newBadges[i];
            const numStr = newId.toString().padStart(2, "0");

            const currentImg = isFlipped
                ? flipper.querySelector(".badge-back img")
                : flipper.querySelector(".badge-front img");

            const oldId = parseInt(currentImg.getAttribute('data-badge-id'));

            if (!isNaN(oldId)) {
                currentSet.delete(oldId);
            }
            currentSet.add(newId);

            // Determine target face (the one hidden right now)
            const targetImg = isFlipped
                ? flipper.querySelector(".badge-front img")
                : flipper.querySelector(".badge-back img");

            // Update target face
            targetImg.src = `./assets/images/badge/badge-${numStr}.png`;
            targetImg.alt = `Badge ${numStr}`;
            targetImg.setAttribute('data-badge-id', newId);

            // Flip
            if (isFlipped) {
                flipper.classList.remove("is-flipped");
            } else {
                flipper.classList.add("is-flipped");
            }
        });

    }, 3000);
};
